module.exports = __webpack_public_path__ + "static/media/7C.3463cf79.svg";